/**
 * Global Functionality
 * The logic in this is intended to ONLY contain any functionality
 * that is required on every page load.
 *
 * NOTE: Please do not include any page-specific logic here.
 **/


// Vars
// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒
require('../lib/assets');

// Logic
// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒
const topBarWithSearch = document.querySelector('.show_search_and_call');
const headerV5 = document.querySelector('.header-v5');
const loaderWrapper = document.querySelector('.predictive-search__loading-state');
const drawerMenuClose = document.querySelectorAll('.menu-top__button-close');
const simpleSlider = document.querySelector('.keen-slider');
const subMenuButtonClose = document.querySelector('.menu-top__button-close-submenu');
const menuList = document.querySelectorAll('.has-submenu.list-menu li');
const tabSlider = document.querySelector('.slider-container');
const countdown = document.querySelector('countdown');

drawerMenuClose.forEach(btn => {
    btn.addEventListener('click' , (e) => {
        const openMenu = document.body.querySelector('.menu-opening');
        const containerMenu = document.body.querySelector('.menu-drawer-container summary');
        if (openMenu) {
            openMenu.classList.remove('menu-opening');
            setTimeout(() => {
                openMenu.removeAttribute('open');
            }, 500);
            document.body.classList.remove('overflow-hidden-tablet');
            containerMenu.setAttribute('aria-expanded' , 'false')
        }
    });
})


const handlerClickCloseButtonSubMenuDrawer = (e) => {
    const subMenuDrawers = document.querySelectorAll('.menu-drawer__menu');
    subMenuDrawers.forEach(menu => {
        const detailsElements = menu.querySelectorAll('details');
        
        detailsElements.forEach(detailsElement => {
            if (detailsElement.id) {
                const subMenuElement = document.getElementById(detailsElement.id);

                if (subMenuElement) {
                    if (subMenuElement.hasAttribute('open')) {
                        subMenuElement.classList.remove('menu-opening');
    
                        if (subMenuButtonClose.classList.contains('active')) {
                            subMenuButtonClose.classList.remove('active')
                        }
                        setTimeout(() => {
                            subMenuElement.removeAttribute('open');
                        }, 500);
                        menu.classList.remove('submenu-open');
                        subMenuElement.querySelector('summary').setAttribute('aria-expanded', 'false')
                    }
                }
            }
        });
    });
}



if (subMenuButtonClose) {
    subMenuButtonClose.addEventListener('click' , handlerClickCloseButtonSubMenuDrawer);
}

menuList.forEach(menu => {
        menu.addEventListener('click' , (e) => {
        subMenuButtonClose.classList.add('active');
    }
)});


topBarWithSearch ? document.body.classList.add('top-bar_search') : null;
simpleSlider ? require('../components/simpleSlider') : null;
tabSlider ? require('../components/tabSlider') : null;
countdown ? require('../components/countdown') : null;

setTimeout(() => {
    headerV5 ? loaderWrapper.style.display = 'flex' : null;
}, 2000);

